// export const databaseUrl = "http://localhost:8000"
// export const databaseUrl = "https://stewards-pharmacy.onrender.com"
export const databaseUrl = "https://api.stewardspharmacy.com"
